import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { IcoBackButton } from "assets/icons";
import styles from "./styles.module.scss";
import { HeaderWithBackProps } from "./types";

export function HeaderWithBack({
	label,
	backTo = "/",
	className
}: HeaderWithBackProps) {
	const navigate = useNavigate();

	const handleBack = () => {
		if (backTo === -1) {
			navigate(-1);
		} else {
			navigate(backTo ?? "/");
		}
	};

	return (
		<div className={clsx(styles.pageHeaderWithBack, className)}>
			<button
				onClick={handleBack}
				className={styles.backButton}
				aria-label="Voltar"
			>
				<IcoBackButton />
			</button>
			<span className={styles.label}>{label}</span>
		</div>
	);
}
